import { render, staticRenderFns } from "./registrationSystemClients.vue?vue&type=template&id=3ac603b5&scoped=true&"
import script from "./registrationSystemClients.vue?vue&type=script&lang=js&"
export * from "./registrationSystemClients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac603b5",
  null
  
)

export default component.exports